<template>
  <div class="raiders">
    <!--中考攻略锦囊部分-->
    <div class="content">
      <div class="title-box">
        <h2 class="title">中考攻略锦囊</h2>
      </div>
      <ul>
        <li v-for="(item, index) in junior" :key="index">
          <a :title="item.title" :href="item.url">{{ item.stitle }}</a>
          <div>- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
          <time>{{item.date.split(' ')[0]}}</time>
        </li>
      </ul>
    </div>
    <div class="blank"></div>
    <!--高考攻略锦囊部分-->
    <div class="content">
      <div class="title-box">
        <h2 class="title">高考攻略锦囊</h2>
      </div>
      <ul>
        <li v-for="(item, index) in senior" :key="index">
          <a :title="item.title" :href="item.url">{{ item.stitle }}</a>
          <div>- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
          <time>{{item.date.split(' ')[0]}}</time>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getArticle,getCMS } from 'js/getArticle.js'
export default {

  name: 'Raiders',
  data () {
    return {
      junior_exam: '4809,8080,8081,8082,10200,14394,1008,1009,1010,1011,8192,8193,8194,8195,8210,10189,1013,1014,1015,8208,8301',
      senior_exam: '1028,1029,1030,1031,1032,1033,1034,1035,1036,1037,8645,8644,15086',
      junior: [],
      senior: [],
      cmsUrl:'http://cmsdt.xdf.cn/get_main_article_for_WWW_js.php',
    }
  },
  created () {
    this.getRaidersData(this.junior_exam,this.junior)
    this.getRaidersData(this.senior_exam,this.senior)
  },
  methods: {
    getRaidersData (typeidsArr, arr) {
      let _this = this
      getCMS(this.cmsUrl,typeidsArr,5).then((response) => {
        response.forEach(element => {
          arr.push(element);
        });
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.raiders
  width: 1200px
  height: 180px
  display: flex
  margin: 18px auto
  .blank
    flex: 1
  .content
    display: flex
    width: 566px
    flex-direction: column
    .title-box
      flex: 2
      font-size: 18px
      line-height: 40px
      border-bottom: 2px solid #a5e1d6
      .title:before
        display: inline-block
        height: 14px
        width: 3px
        background: #38bca4
        content: ""
        margin-right: 6px
    ul
      flex: 7
      display: flex
      flex-direction: column
      li
        flex: 1
        display: flex
        color: #999
        line-height: 28px
        a
          color: #8a8a8a
          font-size: 14px
          float: left
          max-width: 380px
          &:hover
            color: $themeColor
        div
          flex: 1
          white-space: nowrap
          overflow: hidden
          color: #e1e2e1
        time
          background: #FFF
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Raiders.vue